function StartScreen({ level, numQuestions, dispatch }) {
  if (level === null) {
    return (
      <div className="start options">
        <h2>Welcome to The React Quiz!</h2>
        <h3>Please select on of the following levels to start the quiz</h3>
        <button
          className="btn btn-option"
          onClick={() => dispatch({ type: "setLevel", payload: "General" })}
        >
          General
        </button>
        <button
          className="btn btn-option"
          onClick={() => dispatch({ type: "setLevel", payload: "Easy" })}
        >
          Easy
        </button>
        <button
          className="btn btn-option"
          onClick={() => dispatch({ type: "setLevel", payload: "Medium" })}
        >
          Medium
        </button>
        <button
          className="btn btn-option"
          onClick={() => dispatch({ type: "setLevel", payload: "Hard" })}
        >
          Hard
        </button>
      </div>
    );
  } else {
    return (
      <div className="start">
        <h2>Welcome to The {level} React Quiz!</h2>
        <h3>{numQuestions} questions to test your React mastery</h3>
        <button
          className="btn btn-ui"
          onClick={() => dispatch({ type: "start" })}
        >
          Let's start
        </button>
        <button
          className="btn btn-ui"
          onClick={() => dispatch({ type: "setLevel", payload: null })}
        >
          Go back
        </button>
      </div>
    );
  }
}

export default StartScreen;
